import { HOLDINGS_DATA, CAPITAL_GAINS } from '../data/holdings';
import type { Holding, CapitalGains } from '../types';

/**
 * Mock API service with simulated network delay
 */

// Simulate network latency
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Fetch capital gains data
 */
export async function getCapitalGains(): Promise<CapitalGains> {
  await delay(600);
  return CAPITAL_GAINS.capitalGains;
}

/**
 * Fetch user holdings data
 */
export async function getHoldings(): Promise<Holding[]> {
  await delay(800);
  return HOLDINGS_DATA;
}

/**
 * Fetch all required data in parallel
 */
export async function fetchAllData() {
  const [capitalGains, holdings] = await Promise.all([
    getCapitalGains(),
    getHoldings()
  ]);
  
  return { capitalGains, holdings };
}